
const RULE = {
	'ruleValidate':{        //表单验证属性
		account: [
            {required:true, message:'用户名不能为空',trigger:'blur'}
        ],
        name: [
            {required:true, message:'姓名不能为空',trigger:'blur'}
        ],
        password: [
            {required: true, message:'密码不能为空', trigger:'blur'},
            {type:'string',min:6,message:'密码不能少于6位',trigger: 'blur' }
        ],
//      newPsw: [
//          {required: true, trigger:'blur',validator:validatePass},
//          {type:'string',min:6,message:'密码不能少于6位',trigger: 'blur' }
//      ],
//      veriPsw: [
//          {required: true, trigger:'blur',validator:validatePassCheck},
//          {type:'string',min:6,message:'密码不能少于6位',trigger: 'blur' }
//      ],    
        phone: [
            {pattern:/^1[345789]\d{9}$/, message: '请输入正确手机号！', trigger:'blur'},
            
        ],
        mail: [
            { type: 'email', message: '邮箱格式不正确！', trigger:'blur'}
        ],
        downValue: [
            {required: true, message:'下发值不能为空', trigger:'blur'},
        ],
        city: [
            { required: true, message: '请选择城市', trigger: 'change' }
        ],
        gender: [
            { required: true, message: '请选择性别', trigger: 'change' }
        ],
        interest: [
            { required: true, type: 'array', min: 1, message: 'Choose at least one hobby', trigger: 'change' },
            { type: 'array', max: 2, message: 'Choose two hobbies at best', trigger: 'change' }
        ],
        date: [
            { required: true, type: 'date', message: 'Please select the date', trigger: 'change' }
        ],
        time: [
            { required: true, type: 'string', message: 'Please select time', trigger: 'change' }
        ],
        desc: [
            { required: true, message: 'Please enter a personal introduction', trigger: 'blur' },
            { type: 'string', min:20,message: 'Introduce no less than 20 words', trigger: 'blur' }
        ],
        authCode:[
        	{ required: true, message: '请输入验证码', trigger:'blur'}
        ],
	}
};


export default RULE;